import { render, staticRenderFns } from "./Factors.vue?vue&type=template&id=16936a68&scoped=true"
import script from "./Factors.vue?vue&type=script&lang=ts"
export * from "./Factors.vue?vue&type=script&lang=ts"
import style0 from "./Factors.vue?vue&type=style&index=0&id=16936a68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16936a68",
  null
  
)

export default component.exports